import { render, staticRenderFns } from "./Administrator.vue?vue&type=template&id=fbc839fa&"
import script from "./Administrator.vue?vue&type=script&lang=js&"
export * from "./Administrator.vue?vue&type=script&lang=js&"
import style0 from "./Administrator.vue?vue&type=style&index=0&id=fbc839fa&prod&lang=scss&"
import style1 from "./Administrator.vue?vue&type=style&index=1&id=fbc839fa&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports